<template>
  <v-row justify="center">
    <v-dialog v-model="shareDialog.dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Поделиться концепцией</v-card-title>
        <v-card-text>
          <v-form v-model="valid">
            <v-text-field
                label="Имя пользователя"
                v-model="shareDialog.shareUserName"
                :rules="[required, notMe]"
            ></v-text-field>
            <v-text-field
                label="Название концепции"
                v-model="shareDialog.shareConceptName"
                :rules="[required]"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
              color="success"
              text
              @click="handlerShareConcept"
              :disabled="!valid"
          >
            Отправить копию
          </v-btn>
          <v-btn text @click="handlerCloseDialog">Отмена</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "ShareDialog",
  props: {
    shareDialog: Object,
    handlerShareConcept: Function,
    login: String,
  },
  data() {
    return {
      valid: false,
    }
  },
  methods: {
    handlerCloseDialog: function () {
      this.shareDialog.dialog = false
      this.shareDialog.shareUserName = ''
      this.shareDialog.shareConceptName = ''
    },
    required: value => !!value || 'Это обязательное поле.',
    notMe: function(value) {
      return value !== this.login || 'Нельзя расшарить проект себе'
    }
  },
}
</script>
